import { ref, nextTick } from 'vue';
import { defineStore } from 'pinia';

/**
 * Coordinates programmatic actions that should behave like using the commissioning nav menu
 * (e.g. Contact Us lives under NavBarDrawerContent, not duplicated in pages).
 */
export const useCommissioningNavStore = defineStore('commissioningNav', () => {
  /**
   * One-shot pulse: set true so watchers open the nav + Contact Us, then cleared on nextTick
   * so another action can raise it again (a plain "show" boolean that stayed true would not
   * re-trigger `watch` on a second tap).
   */
  const contactUsViaNavRequested = ref(false);

  function requestContactUsViaNavBar() {
    contactUsViaNavRequested.value = true;
    nextTick(() => {
      contactUsViaNavRequested.value = false;
    });
  }

  return {
    contactUsViaNavRequested,
    requestContactUsViaNavBar,
  };
});
